import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import API_CONFIG from '../config/api';

const useFaqs = (options = {}) => {
  const { i18n } = useTranslation();
  const { enableApi = true } = options;
  
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Transformer les FAQ de l'API au format attendu par FAQSearch
  const transformFaqs = (data, lang) => {
    if (!Array.isArray(data)) return [];
    
    return data.map(faq => {
      // Récupérer la traduction pour la langue actuelle avec fallback sur EN
      const translation = faq.translations?.[lang] || faq.translations?.en || {};
      
      return {
        question: translation.question || '',
        answer: translation.answer || '',
        category: faq.category || 'ETA-IL'
      };
    }).filter(faq => faq.question && faq.answer); // Exclure les FAQ sans question/réponse
  };

  // Récupérer les FAQ depuis l'API
  useEffect(() => {
    if (!enableApi) return;
    
    const fetchFaqs = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const normalizedLang = i18n.language.split('-')[0]; // fr-FR -> fr
        
        // URL de l'API pour récupérer les FAQ
        const apiUrl = `${API_CONFIG.baseURL}/api/getStaticData?type=faq`;
        
        
        const response = await fetch(apiUrl, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
        
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();

        // console.log('📊 Raw FAQ data:', result);
        // Gérer les différents formats de réponse
        // Le backend getStaticData retourne directement le tableau
        // Le backend WebStaticSite retourne { data: [...] }
        let rawFaqs = [];
        if (Array.isArray(result)) {
          // Format direct : [...]
          rawFaqs = result;
        } else if (result.data) {
          // Format avec data : { data: [...] }
          rawFaqs = Array.isArray(result.data) ? result.data : [];
        } else if (result.body) {
          // Format avec body : { body: [...] }
          rawFaqs = Array.isArray(result.body) ? result.body : [];
        }
        
        // console.log('📋 FAQ array:', rawFaqs);
        
        // Transformer les FAQ pour la langue actuelle
        const transformed = transformFaqs(rawFaqs, normalizedLang);
        //  console.log('🌍 Transformed FAQs:', transformed);
        
        setFaqs(transformed);
      } catch (err) {
        // console.error('❌ Error loading FAQs:', err);
        setError(err.message);
        // En cas d'erreur, on laisse le tableau vide
        // Le composant GetHelp utilisera le fallback sur translation.json
        setFaqs([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchFaqs();
  }, [enableApi, i18n.language]);

  return {
    faqs,
    loading,
    error,
    refresh: () => window.location.reload()
  };
};

export default useFaqs;

